import { FC } from "react";
import SmartSearchMonthYearAndActionsLayout from "../../../components/Layouts/smart-search-month-year-and-actions-layout";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import { getLocationLG861e } from "../../../services/reports";
import { ValidationEnum } from "../../../enums/validationEnum";
import {SearchStatusEnum} from "../../../enums/searchStatusEnum";

const LocationLG861e: FC = () => {
  return (
    <SmartSearchMonthYearAndActionsLayout
      searchBy={[SearchOptionEnum.LOCATION]}
      status={SearchStatusEnum.ACTIVE  + "," +  SearchStatusEnum.CLOSED  + "," +  SearchStatusEnum.INACTIVE}
      validOnEmpty={false}
      actions={[ActionButtonEnum.REFRESH, ActionButtonEnum.SAVE_PDF]}
      minYear={2014}
      validations={[
        ValidationEnum.VALIDATE_SMART_SEARCH
      ]}
      onRefresh={(output, month, year, params) => {
        const monthNumber : number = Number(month) + 1;
        const monthStr : string = String(monthNumber);
        return getLocationLG861e({
          output,
          locationId: params.id!,
          month: monthStr,
          year
        });
      }}
    />
  );
};

export default LocationLG861e;
